import React from 'react';
import icon1 from '../../assets/img/serviceexplore/1.png';
import icon2 from '../../assets/img/serviceexplore/2.png';
import icon3 from '../../assets/img/serviceexplore/3.png';
import icon4 from '../../assets/img/serviceexplore/4.png';
import icon5 from '../../assets/img/serviceexplore/5.png';
import icon6 from '../../assets/img/serviceexplore/6.png';

const ServiceExplore = () => {
  const exploreCards = [
    {
      icon: icon1,
      title: "Architectural As-Built Modeling",
      desc: "Using specialized tools and processes developed specifically for architecture, we create 3D models that include exact representatives of every aspect of your project. Accurate modeling of spaces will help ensure that renovation and facility management (FM) will go smoothly and successfully."
    },
    {
      icon: icon2,
      title: "Structural As-Built Modeling",
      desc: "Columns, beams, slabs, and foundations are all critical structural elements in any project, but accuracy is vital for creating future retrofit or expanded projects. Our team of detailers captures every aspect of your project so that your finished project meets your expectations regarding quality and safety."
    },
    {
      icon: icon3,
      title: "MEPF As-Built Modeling",
      desc: "As a result of our advanced scanning methods for true as-built modeling of HVAC, plumbing, electrical, and fire systems, our clients enjoy the peace of mind that their models are accurate and up-to-date. An accurate HVAC, plumbing, electrical, and fire system layout provides clients with reliable coordination among trades for all upgrades or repairs necessary to keep facilities safe."
    },
    {
      icon: icon4,
      title: "Scan to BIM for As-Built Documentation",
      desc: "Using raw point cloud data, we turn that data into intelligent and detailed 3D BIM Models (LOD 100-Lod 500) to provide our clients with the clear and accurate representation of their documentation processes that they can expect from their manufacturers' documents."
    },
    {
      icon: icon5,
      title: "CAD to BIM Conversion for As-Built Models",
      desc: "CAD to BIM for As-Built Models by converting 2D drawings into 3D BIM Models will allow for all of the existing documents in your system to be properly accounted for at this time."
    },
    {
      icon: icon6,
      title: "Asset Tagging & COBie Data Integration",
      desc: "In addition to geometry, we also enhance your models with asset-level data and COBie compliance. This will support Operations, Maintenance and Digital Twin strategies."
    }
  ];

  return (
    <section className="service-explore-section">
      <div className="service-explore-container">
        <div className="explore-header">
          <h2 className="explore-title">
            <span className="text-primary">Our </span>As-Built BIM Modeling Services
          </h2>
          <p className="explore-subtitle">
            Our specialist team of 100+ dedicated bim professionals can help you convert your laser scans and 2D documents into construction-ready Revit models accurately representing the real world around us. Using precision tools along with advanced building information modeling (BIM) software, we create models for all disciplines - architectural, structural, and MEPF - and represent exactly what is in place in the field today          </p>
        </div>

        <div className="explore-grid">
          {exploreCards.map((card, index) => (
            <div key={index} className="explore-card">
              <div className="explore-icon">
                <img src={card.icon.src || card.icon} alt={card.title} style={{ width: '95px', height: '85px', objectFit: 'contain' }} />
              </div>
              <h3 className="explore-card-title">{card.title}</h3>
              <p className="explore-card-text">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceExplore;
